import {useEffect, useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import {getThirdVouchers, groupTicketsByEvents} from "../api/events.ts";
import useDataStore from "../store/dataStore.ts";
import {useNavigate} from "react-router-dom";
import {formatDateToFrench, getDay, getMonth} from "../utils/dateUtils.ts";
import {CalendarDays, MapPin, Ticket} from "lucide-react";
import GoBackHeader from "../components/GoBackHeader.tsx";
import EventsSkeleton from "../components/skeletons/EventsSkeleton.tsx";

const EventsPurchased = () => {
    const myPhoneNumber = useDataStore.getState().myPhoneNumber;
    const [tickets, setTickets] = useState([]);
    const navigate = useNavigate();
    const { data, isLoading,isError } = useQuery({
        queryKey: ["ThirdVouchers", myPhoneNumber], // Inclure le numéro de téléphone dans la clé
        queryFn: () => getThirdVouchers(myPhoneNumber || ''),
        staleTime: 5000,
    });

    const myTickets = useDataStore.getState().myTickets;

    useEffect(() => {
        if (data?.length > 0) {
            const newArray = groupTicketsByEvents(data);
            useDataStore.getState().setMyTickets(newArray);
        } else if (data === undefined && !isLoading && !isError) {
            // Si la requête a échoué et qu'il n'y a pas de données existantes dans le store
            if (!myTickets?.length) {
                useDataStore.getState().setMyTickets([]); // Réinitialiser avec tableau vide si aucune donnée
            }
        }
    }, [data, isLoading, isError, myTickets]);

    useEffect(()=>{
        if (data?.length > 0) {
            const newArray = groupTicketsByEvents(data);
            setTickets(newArray);
        } else {
            const myTickets = useDataStore.getState().myTickets;
            setTickets(myTickets);
        }
    },[data]);

    const navigateToTickets = (tickets: any) => {
         navigate('/events-purchased-tickets', {
            state: {
                tickets
            }
        });
    }

    useEffect(()=>{
        if (!myPhoneNumber){
            navigate('/otp')
        }
    },[])


    const renderContent = () => {
        if(isLoading) return  <EventsSkeleton/>;
        if(data && !data.length || !Array.isArray(data) ) {
            return <div className='flex flex-col justify-center items-center'>
                <img className='size-32' src='/papier.png' alt='No data Img'/>
                <p className='text-gray-700 font-bold text-center'>Une erreur s'est produite lors de la récupération de vos tickets . </p>
                <p className='text-black text-center my-6'>Veuillez réessayer plus tard.</p>
                <p className='text-black text-center'>Si le problème persiste , appelez le service client au <span className={'underline'}>+228 93 15 15 17</span>.</p>
            </div>
        }

        return (
            tickets?.length > 0 && tickets?.map((item: { event: any, tickets: any }) => {
                const event = item?.event;
                return (
                    <div className="flex justify-center items-center mb-4">
                        <div className="flex flex-col text-xl mr-2">
                            <span className="font-extrabold">{getDay(event?.eventDate)}</span>
                            <span className="font-light">{getMonth(event?.eventDate)}</span>
                        </div>
                        <button onClick={() => navigateToTickets(item?.tickets)}
                                className="bg-white shadow-lg border text-black h-32 rounded-lg max-w-sm flex">
                            <div className="flex-1 min-w-[50vw] flex flex-col justify-center px-4 py-4 ">
                                <h3 className="text-[#194E6E] font-bold break-words text-base my-1">{event?.title}</h3>
                                <div className="flex items-center">
                                    <CalendarDays size={20}/>
                                    <p className="text-[#4B4E50] text-sm mx-1">
                                        {formatDateToFrench(event?.eventDate)}
                                    </p>
                                </div>
                                <div className="flex items-center mt-2">
                                    <MapPin size={20}/>
                                    <p className="text-[#4B4E50] text-sm break-words mx-1">
                                        {event?.eventPlace}
                                    </p>
                                </div>
                                <div className="flex items-center mt-2">
                                    <Ticket size={20}/>
                                    <p className="text-[#4B4E50] text-sm  break-words mx-1">
                                        {item?.tickets?.length || 0} ticket(s)
                                    </p>
                                </div>
                            </div>

                            <div className="w-34">
                                <img
                                    src={event?.eventImage || "https://placehold.jp/150x150.png"}
                                    alt=""
                                    className="h-full w-full object-cover rounded-r-lg"
                                />
                            </div>
                        </button>
                    </div>
                );
            })
        )
    }


    return (
        <div
            style={{
                backgroundImage: `url('/pattern-white.svg')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
            className="min-h-screen py-4 px-2 flex flex-col "
        >
            <GoBackHeader/>
            <div className="mt-14 px-2">
                <div className={'flex justify-between pb-6'}>
                    <div>
                        <p>Numéro de téléphone :</p>
                        <p className='font-bold text-primary'>{myPhoneNumber}</p>
                    </div>
                    <button className="px-4 bg-white rounded-lg border shadow text-third" onClick={() =>{
                        useDataStore.getState().setMyPhoneNumber('');
                        navigate('/otp');
                    }}>
                        Modifier
                    </button>
                </div>
                {renderContent()}
            </div>
        </div>
    );
};

export default EventsPurchased;
